import { useState } from "react";
import { Copy, Link2, MessageCircle, Mail, Share2, X, Check, Ban } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Spin } from "@/components/common";

export const shareUrl = (token) => `${window.location.origin}/paylas/${token}`;

export function ShareDialog({ kind, item, open, onClose, onChange }) {
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);
  if (!item) return null;
  const url = item.share_token ? shareUrl(item.share_token) : "";
  const text = `${item.book_title} — ${kind === "film" ? "filmini izleyin" : "kitabını okuyun"} (ZOR Dijital Yayınevi)`;
  const create = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/share/${kind}/${item.id}`); onChange?.({ ...item, share_token: data.token }); toast.success("Paylaşım bağlantısı oluşturuldu"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const revoke = async () => { await api.delete(`/share/${kind}/${item.id}`); onChange?.({ ...item, share_token: "" }); toast("Paylaşım kapatıldı"); };
  const copy = async () => { await navigator.clipboard.writeText(url); setCopied(true); toast.success("Bağlantı kopyalandı"); setTimeout(() => setCopied(false), 2000); };
  const native = () => navigator.share?.({ title: item.title, text, url }).catch(() => {});
  const enc = encodeURIComponent;
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid="share-dialog">
        <DialogHeader><DialogTitle className="font-serif-d text-2xl text-navy">Paylaş</DialogTitle></DialogHeader>
        <p className="text-sm text-[#5f6f84] -mt-2">{item.title}</p>
        {!url ? (
          <div className="text-center py-6"><p className="text-sm text-[#5f6f84] mb-4">Bağlantıya sahip herkes giriş yapmadan {kind === "film" ? "filmi izleyebilir" : "PDF'i görüntüleyip indirebilir"}.</p>
            <button onClick={create} disabled={busy} className="btn-teal px-5 py-3 flex items-center gap-2 mx-auto" data-testid="create-share-link-btn">{busy ? <Spin /> : <Link2 size={17} />} Paylaşım bağlantısı oluştur</button></div>
        ) : (
          <div className="space-y-4">
            <div className="flex gap-2"><input readOnly value={url} className="inp text-sm" data-testid="share-link-input" />
              <button onClick={copy} className="btn-teal px-4 flex items-center gap-1" data-testid="copy-share-link-btn">{copied ? <Check size={16} /> : <Copy size={16} />} Kopyala</button></div>
            <div className="grid grid-cols-4 gap-2 text-xs">
              <a href={`https://wa.me/?text=${enc(text + " " + url)}`} target="_blank" rel="noreferrer" className="btn-ghost py-3 flex flex-col items-center gap-1" data-testid="share-whatsapp"><MessageCircle size={20} className="text-[#25a35a]" /> WhatsApp</a>
              <a href={`https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(url)}`} target="_blank" rel="noreferrer" className="btn-ghost py-3 flex flex-col items-center gap-1" data-testid="share-x"><X size={20} /> X</a>
              <a href={`mailto:?subject=${enc(item.title)}&body=${enc(text + "\n" + url)}`} className="btn-ghost py-3 flex flex-col items-center gap-1" data-testid="share-email"><Mail size={20} className="text-[#1a6fd0]" /> E-posta</a>
              <button onClick={native} className="btn-ghost py-3 flex flex-col items-center gap-1" data-testid="share-native"><Share2 size={20} className="text-teal" /> Diğer</button>
            </div>
            <div className="flex justify-between items-center text-xs text-[#6b7a8c]"><span>{item.views || 0} görüntülenme</span>
              <button onClick={revoke} className="flex items-center gap-1 text-[#d1453b]" data-testid="revoke-share-btn"><Ban size={13} /> Paylaşımı kapat</button></div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
